export default "__VITE_ASSET__Cqp1Wp$F__"